module.exports = __webpack_public_path__ + "static/media/1417873052.984a1ef7.ttf";